// Libraries
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTools } from '@fortawesome/pro-regular-svg-icons';

// Components
import StateScreen from './StateScreen';

// Constants
import { MAINTENANCE_MESSAGE } from '../../../utils/constants/constants';

/**
 * @function MaitenanceMode
 * Describe the component's function
 *
 * @example
 * return (
 *   <MaitenanceMode />
 * )
 */
function MaitenanceMode(): JSX.Element {
    return (
        <StateScreen
            icon={<FontAwesomeIcon icon={faTools} />}
            title={
                process.env.REACT_APP_MAINTENANCE_MESSAGE !== undefined
                    ? process.env.REACT_APP_MAINTENANCE_MESSAGE
                    : MAINTENANCE_MESSAGE
            }
        />
    );
}

// Exports
export default MaitenanceMode;
